<template>
  <div>

   <b-form @submit="onSubmit" @reset="onReset">

    <div class="clearfix pt-3">
        <b-button v-if="editMode" type="reset" :pressed.sync="editMode"  size="sm" variant="danger" class="float-right ml-3">
        abbrechen
        </b-button>
        <b-button v-if="!editMode" :pressed.sync="editMode" variant="default" class="profile_button float-right">
          <span class="bi-pencil" aria-hidden="true"></span>
        </b-button>
        <b-button type="submit" v-if="editMode" size="sm" variant="primary" class="float-right"
          aria-label="Left Align">speichern
        </b-button>
    </div>
<div v-if="!editMode" class="pt-3">
<b-alert :show="groupedKunden().length===0">keine Einträge</b-alert>
</div>
    <div v-if="!editMode" v-for="(cat, idx) in groupedKunden()" :key="idx">
    <h3 class="underline">{{cat.category.name }}</h3>
    <b-list-group v-for="(sender, fidx) in cat.items" :key="fidx">
       <b-list-group-item :class="plistClass(sender.priority)">
       {{sender.sender.name}}
        </b-list-group-item>
    </b-list-group>
    </div>
    <div v-if="editMode">
    <div class="row">
      <div class="col-xs-12 col-lg-8">
      <b-form-group
          id="input-group-13"
          label="Kategorie"
          label-for="input-13">
            <b-form-select
              id="input-13"
              v-model="kategorie"
              @change="switchSender"
              required>
              <option v-for="sk in categories" :key="sk.id" :value="sk.id">{{sk.name}}</option>
            </b-form-select>
      </b-form-group>
    </div>
    </div>

    <div class="row">
    <div class="col-xs-12 col-lg-8">
    <div class="clearfix">
     <label class="d-block">Reihenfolge
     <div class="float-right">
        <b-button  :pressed.sync="collapseSort" variant="outline-secondary" size="sm">
             <i v-if="collapseSort" class="bi bi-chevron-down"></i>
             <i v-if="!collapseSort" class="bi bi-chevron-up"></i>
        </b-button>
      </div>
     </label>
     </div>
      <b-collapse v-model="collapseSort">
     <b-card no-body>
    <draggable
       tag="ul"
        :list="categories"
        class="list-group"
        ghost-class="ghost"
      >
     <transition-group type="transition" name="flip-list">
    <li
          class="list-group-item clickable"
          v-for="element in categories"
          :key="element.weight"
        >
          <i  v-b-tooltip.hover title="Ziehen um zu sortieren" class="bi bi-grip-vertical"></i>
          {{ element.name }}
        </li>
       </transition-group>
      </draggable>

      </b-card>
      </b-collapse>
    </div>
    </div>
    <div class="row">
    <div class="col-xs-12 col-lg-8">
      <b-form-group
          id="input-group-11"
          label="Filter"
          label-for="input-11">
         <b-form-input id="input-1" v-model="filter" type="text" placeholder="Auswahl einschränken..."/>
      </b-form-group>
    </div>
  </div>
      <div class="row">
          <div class="col-xs-12 col-lg-8">
          <b-alert :show="filteredSender().length===0">keine Einträge</b-alert>
          <b-list-group v-for="sender in filteredSender()" :key="sender.id">
             <b-list-group-item :class="listClass(sender.id)">
             <b-input-group >
             <b-input-group-prepend>
             <b-form-checkbox v-model="checked[sender.id]" name="check-button"></b-form-checkbox>
             </b-input-group-prepend>
                 <b-form-input size="sm" :value="sender.name" readonly plaintext></b-form-input>
             <b-input-group-append>
             <b-button v-if="checked[sender.id]" :pressed.sync="collapseOpen[sender.id]" variant="default" size="sm">
               <i v-if="!collapseOpen[sender.id]" class="bi bi-chevron-down"></i>
               <i v-if="collapseOpen[sender.id]" class="bi bi-chevron-up"></i>
             </b-button>
             </b-input-group-append>
             </b-input-group>
            <b-collapse v-if="checked[sender.id]" v-model="collapseOpen[sender.id]">
             <b-card no-body style="border:0">
             <b-form-radio-group  class="pt-3"
                  :id="radioGroupId(sender.id)"
                  v-model="prioritySelected[sender.id]"
                  :options="priorityOptions"
                  aria-describedby="Priorität für Profilanzeige"
                  :name="radioGroupName(sender.id)"
                ></b-form-radio-group>
                </b-card>
              </b-collapse>
              </b-list-group-item>
          </b-list-group>
          <b-button class="mt-3" @click="requestLogo()" variant="outline-primary">fehlende Logos anfordern</b-button>
      </div>
    </div>
   </div>
  </b-form>
  </div>
</template>

<script>
import api from '@/api/benutzer'
import workflowApi from '@/api/workflow'
import draggable from 'vuedraggable'
import utils from '@/utilities'

export default {
  name: 'ProfilKunden',
  props: ['user', 'profil'],
  components: {
    draggable
  },
  mounted () {
    this.updateItems(this.user)
  },
  watch: {
    // wenn der user manchmal erst geladen wird müssen schauen wann das neue user object kommt
    user: function (newUser, oldUser) {
      this.updateItems(newUser)
    }
  },
  methods: {
    async requestLogo () {
      let message = prompt('Welches Logo wollen Sie anfordern?')
      if (message) {
        let result = await workflowApi.simpleAction(0, message)
        let error = result['errorMessage'] ? result['errorMessage'] : (result['errors'] ? result['errors']['errorMessage'] : null)

        if (result && !error) {
          utils.makeToast(this, 'Nachricht verschickt!', 'success')
        } else {
          utils.makeToast(this, error, 'danger')
        }
      }
    },
    findSender (senderid) {
      for (let senderCat in this.$store.state.auth.baseData.sender) {
        for (let i = 0; i < this.$store.state.auth.baseData.sender[senderCat].length; i++) {
          if (this.$store.state.auth.baseData.sender[senderCat][i].id === senderid) {
            return {'category': this.$store.state.auth.baseData.senderCategories[senderCat], 'sender': this.$store.state.auth.baseData.sender[senderCat][i]}
          }
        }
      }
      return {}
    },
    compareLogo (s1, s2) {
      if (s1.sender.logoname && s2.sender.logoname) {
        return s1.sender.logoname.localeCompare(s2.sender.logoname)
      }
      return s1.sender.weight - s2.sender.weight
    },
    groupedKunden () {
      // die kundenliste nach Sender Kategorien gruppieren
      let kunden = {}
      if (this.user.kunden) {
        for (let i = 0; i < this.user.kunden.length; i++) {
          const sender = this.findSender(this.user.kunden[i].id.senderId)
          if (sender.category) {
            let cat = kunden[sender.category.name]
            if (!cat) {
              cat = {'category': sender.category, 'items': []}
            }
            cat['category'] = sender.category
            cat['items'].push({'sender': sender.sender, 'priority': this.user.kunden[i].prioritaet})
            cat['items'] = cat['items'].sort((s1, s2) => (s2.priority - s1.priority !== 0 ? s2.priority - s1.priority : this.compareLogo(s1, s2)))
            kunden[sender.category.name] = cat
          } else {
            console.log('sender', sender)
          }
        }
        let tmp = []
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(kunden)) {
          tmp.push(value)
        }
        tmp.sort((a, b) => this.categorySort(a.category, b.category))
        return tmp
      }
      return kunden
    },
    updateItems (user) {
      if (user && user.kunden) {
        for (let i = 0; i < user.kunden.length; i++) {
          this.checked[user.kunden[i].id.senderId] = true
          this.prioritySelected[user.kunden[i].id.senderId] = user.kunden[i].prioritaet
        }
      }
      this.categories = this.categories.sort(this.categorySort)
      this.orginalCategories = this.categories.sort(this.categorySort)
      this.switchSender()
    },
    indicatorId (id) {
      return 'collapse-icon-' + id
    },
    colapseId (id, quote) {
      if (quote) {
        return '\'collapse-id-' + id + '\''
      }
      return 'collapse-id-' + id
    },
    plistClass (prio) {
      return 'prio' + prio
    },
    listClass (index) {
      return 'prio' + this.prioritySelected[index]
    },
    radioGroupName (index) {
      return 'radio-options-' + index
    },
    radioGroupId (index) {
      return 'radio-group-' + index
    },
    filteredSender () {
      if (this.senderListe) {
        if (this.filter) {
          return this.senderListe.filter(sender => sender.name.toLowerCase().includes(this.filter.toLowerCase()), this)
        }
        return this.senderListe
      }
      return []
    },
    switchSender () {
      this.filter = null
      if (this.kategorie) {
        this.senderListe = this.$store.state.auth.baseData.sender[this.kategorie]
      } else {
        this.senderListe = {}
      }
    },
    async onSubmit (event) {
      event.preventDefault()
      event.stopPropagation()
      if (!this.editMode) {
        this.editMode = !this.editMode
        return
      }
      const cats = this.$store.state.auth.baseData.senderCategories
      let kunden = []
      for (let cat in cats) {
        const senderListe = this.$store.state.auth.baseData.sender[cat]
        if (senderListe) {
          for (let i = 0; i < senderListe.length; i++) {
            if (this.checked[senderListe[i].id]) {
              let kunde = {}
              kunde.id = senderListe[i].id
              kunde.priority = this.prioritySelected[senderListe[i].id] ? this.prioritySelected[senderListe[i].id] : 2
              kunden.push(kunde)
            }
          }
        }
      }
      let orders = []
      for (let i = 0; i < this.categories.length; i++) {
        let order = {}
        order.id = this.categories[i].id
        order.order = i
        orders.push(order)
      }

      let result = await api.setKunden(this.user.id, {'kunden': kunden, 'orders': orders})
      if (result && !result.errorMessage) {
        this.editMode = false
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
        // eslint-disable-next-line
        utils.makeToast(this.$root, this.$route.params.id != 0 ? 'Eintrag geändert!' : 'Eintrag angelegt', 'success')
        this.form.titel = ''
        this.filter = ''
      } else {
        utils.makeToast(this.$root, result['errorMessage'], 'danger')
      }
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      this.form = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    categorySort (c1, c2) {
      let w1 = c1.weight
      let w2 = c2.weight
      if (this.user.kundenSortierung) {
        if (this.user.kundenSortierung[c1.id] != null) {
          w1 = this.user.kundenSortierung[c1.id]
        }
        if (this.user.kundenSortierung[c2.id] != null) {
          w2 = this.user.kundenSortierung[c2.id]
        }
      }
      return w1 - w2
    },
    filtered ($cats) {
      let cats = []
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.$store.state.auth.baseData.senderCategories)) {
        if (value.anzeigenKunden) {
          cats.push(value)
        }
      }
      return cats.sort(this.categorySort)
    }
  },
  data () {
    return {
      filter: '',
      senderListe: [],
      categories: this.filtered(this.$store.state.auth.baseData.senderCategories),
      orginalCategories: this.filtered(this.$store.state.auth.baseData.senderCategories),
      checked: [],
      collapseSort: false,
      collapseOpen: [],
      priorities: [],
      show: false,
      editMode: false,
      kategorie: 1,
      prioritySelected: [],
      categoryOrder: [],
      priorityOptions: [
        {text: 'hohe Priorität', value: 3},
        {text: 'mittlere Priorität', value: 2},
        {text: 'niedrige Priorität', value: 1}
      ],
      form: {}
    }
  }
}
</script>

<style scoped>
.buttons {
  margin-top: 35px;
}

.prio1 {
  border-left-color: #777;
  border-left-width: 3px;
}
.prio2 {
  border-left-color: green;
  border-left-width: 3px;
}
.prio3 {
  border-left-color: orange;
  border-left-width: 3px;
}
</style>



// WEBPACK FOOTER //
// src/main/vue/components/profil/Kunden.vue